<template>
  <div class="operate-log">
    <div class="page-search-block">
      <div class="m-b-18">
        <!-- <span class="w-90 inline-block align-r m-r-8">高级筛选：</span> -->
        <div class="inline-block m-r-8">
          <span class="inline-block align-r m-r-8">操作时间：</span>
          <el-date-picker
            class="m-r-5"
            v-model="dateRange"
            type="daterange"
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="YYYY-MM-DD"
          />
        </div>
        <div class="m-b-18 inline-block">
          <span class="inline-block align-r m-r-8">操作用户：</span>
          <el-input
            class="w-120 m-r-20"
            v-model.trim="search.userName"
            placeholder="请输入"
          ></el-input>
        </div>
        <el-button class="submit-btn" size="large" @click="getQuery"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="page-operate-block">
      <span class="tit">操作日志列表</span>
    </div>

    <div class="table-list-block">
      <r-table
        ref="operateLogTable"
        :dataSource="logList"
        :columns="tableColumns"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
      ></r-table>
    </div>
  </div>
</template>

<script>
import RTable from '@/components/common/RTable'
import tableMix from "@/components/common/tableListMixin.js";
import { mapActions } from "vuex";

export default {
  components: { RTable },
  mixins: [tableMix],
  data() {
    return {
      logList: [],
      tableColumns: [],
      pagination: { total: 0, pageIndex: 1, pageSize: 20 },
      dateRange: '',
      search: {
        userName: ''
      }
    }
  },

  created() {
    this.initTableColumn()
    this.getQuery()
  },

  methods: {
    ...mapActions(["fetchData"]),

    // 获取保洁任务列表
    getQuery() {
      let url = 'OPERATE.LOG.GET_LIST';
      let params = { pageSize: this.pagination.pageSize, pageNumber: this.pagination.pageIndex };
      if (this.dateRange) {
        params['requestStartTime'] = this.dateRange[0] + ' 00:00:00'
        params['requestEndTime'] = this.dateRange[1] + ' 23:59:59'
      }
      this.search.userName && (params['userName'] = this.search.userName);

      this.fetchData({
        url,
        method: 'get',
        params,
      }).then(res => {
        this.logList = res?.data || [];
        this.pagination.total = res?.rowCount || 0
      })
    },

    // 初始化table
    initTableColumn() {
      this.tableColumns = [
        { prop: 'account', label: '操作用户' },
        { prop: 'clientTypeName', label: '操作客户端' },
        { prop: 'requestIp', label: '操作IP' },
        { prop: 'requestName', label: '操作名称' },
        { prop: 'requestTime', label: '操作时间' },
        { prop: 'requestBody', label: '操作内容' },
        { prop: 'executeTime', label: '操作耗时',width:150 },
        { prop: 'responseBody', label: '操作结果' },
        // { prop: 'resultExplain', label: '操作说明' },
      ]
    }
  }
}
</script>